/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

export const SELECTED_SPONSOR = 'SELECTED_SPONSOR';
export const UAT_MESSAGE = 'YOU ARE IN TEST MODE';
export const EXIT_TEST_COPY = 'Exit test copy';
export const WEB_PAGE_TITLE = 'eConsent Manager | Signant Health';
